import React from 'react';
import './IconButton.css';

const icons = {
  edit: 'fa-edit',
  delete: 'fa-trash',
  add: 'fa-plus',
  invoice: 'fa-file-invoice',
  viewInvoice: 'fa-file-invoice-dollar',
  email: 'fa-envelope',
  preview: 'fa-eye',
  check: 'fa-check',
  refresh: 'fa-refresh',
  inProgress: 'fa-clock',
  completed: 'fa-check-circle',
  pdf: 'fa-file-pdf',
  print: 'fa-print',
  key: 'fa-key',
  sell: 'fa-hand-holding-usd'
};

function IconButton({ icon, onClick, title, className = '', disabled = false }) {
  const iconClass = icons[icon] || icon;
  
  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (onClick && !disabled) {
      onClick(e);
    }
  };
  
  return (
    <button
      className={`icon-button ${className}`}
      onClick={handleClick}
      onMouseDown={(e) => e.preventDefault()}
      title={title}
      disabled={disabled}
      type="button"
    >
      <i className={`fas ${iconClass}`}></i>
    </button>
  );
}

export default IconButton;

